"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importStar(require("react"));
const has_1 = __importDefault(require("lodash/has"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const shallow_1 = require("zustand/shallow");
const UserContext_1 = require("context/UserContext");
const useAdjustWeightModal_1 = require("hooks/useAdjustWeightModal/useAdjustWeightModal");
const useUrl_1 = require("hooks/useUrl");
const useValidationMinMax_1 = __importDefault(require("hooks/useValidationMinMax"));
const AdjustCategory_1 = __importDefault(require("components/modal/AdjustWeightModal/adjust-weight-detail/AdjustCategory"));
const AdjustCompexity_1 = __importDefault(require("components/modal/AdjustWeightModal/adjust-weight-detail/AdjustCompexity"));
const InputWeight_1 = __importDefault(require("components/modal/AdjustWeightModal/adjust-weight-detail/InputWeight"));
const ObjectiveName_1 = __importDefault(require("components/modal/AdjustWeightModal/adjust-weight-detail/ObjectiveName"));
const Slider_1 = __importDefault(require("components/modal/AdjustWeightModal/adjust-weight-detail/Slider"));
const ToggleWeight_1 = __importDefault(require("components/modal/AdjustWeightModal/adjust-weight-detail/ToggleWeight"));
const WarningLockedWeight_1 = __importDefault(require("components/modal/AdjustWeightModal/adjust-weight-detail/WarningLockedWeight"));
/*
  return true if passing nextProps to render would return
  the same result as passing prevProps to render,
  otherwise return false
*/
const areEqual = (prevProps, nextProps) => (0, isEqual_1.default)(prevProps, nextProps);
const AdjustWeightDetail = react_1.default.memo(({ objective, isLastIndex, index }) => {
    const { config: { enableObjectiveCategoryWithRangedWeight, objectiveWeightTypeOptions, permissions: { objectiveWeightManage } } } = (0, UserContext_1.useUser)();
    const { url } = (0, useUrl_1.useUrl)();
    const { isPercentageConfig, isCreate, isComplexity, isParent, handleChangeWeightError, objectiveCategories, isSubGoal } = (0, useAdjustWeightModal_1.useAdjustWeightModalStore)((state) => ({
        isPercentageConfig: state.isPercentage,
        isCreate: state.isCreate,
        isComplexity: state.isComplexity,
        isParent: state.isParent,
        handleChangeWeightError: state.handleChangeWeightError,
        objectiveCategories: state.objectiveCategories,
        isSubGoal: state.isSubGoal
    }), shallow_1.shallow);
    const { id: objectiveId, isUsingWeight: usingWeight, weight } = objective;
    const { checkValidationSoftWarning, isShowWarning, warningMessage } = (0, useValidationMinMax_1.default)(!isNaN(weight) ? weight || 0 : 0, !isParent || isSubGoal);
    const isCreateTeam = isCreate && location.pathname.includes('/team');
    const goalType = objective?.teamId || isCreateTeam ? 'team_goal' : objective.type;
    const isAllowedObjectiveCategory = objectiveWeightTypeOptions.includes(goalType);
    const isPercentage = isPercentageConfig ||
        !isAllowedObjectiveCategory ||
        url.includes('teams/squad');
    const isAllowToUpdate = isCreate || url.includes('teams/squad')
        ? true
        : objective?.permissions
            ? objective?.permissions?.includes('update')
            : false;
    const allowWarning = enableObjectiveCategoryWithRangedWeight
        ? true
        : isPercentage;
    const isLocked = (enableObjectiveCategoryWithRangedWeight &&
        objective?.objectiveCategory?.isLocked) ||
        false;
    const isErrorWeightShow = !isLocked && isShowWarning && objectiveWeightManage;
    const isErrorLockedWeightShow = !isPercentage &&
        isLocked &&
        objectiveWeightManage &&
        objective?.objectiveCategory?.weight != objective?.weight;
    (0, react_1.useEffect)(() => {
        if (allowWarning) {
            checkValidationSoftWarning(usingWeight);
        }
    }, [weight, allowWarning, usingWeight, checkValidationSoftWarning]);
    (0, react_1.useEffect)(() => {
        if (enableObjectiveCategoryWithRangedWeight && objectiveWeightManage) {
            handleChangeWeightError(objectiveId, isShowWarning);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enableObjectiveCategoryWithRangedWeight,
        isShowWarning,
        objectiveWeightManage
    ]);
    return (react_1.default.createElement("div", { className: `flex ${isLastIndex ? '' : 'mb-[16px]'}` },
        react_1.default.createElement("div", { className: "min-w-[376px] mr-[24px]" },
            react_1.default.createElement(ObjectiveName_1.default, { objective: objective })),
        react_1.default.createElement("div", { className: "w-full" },
            react_1.default.createElement("div", { className: "w-full flex items-center" },
                react_1.default.createElement("div", { className: `${objectiveWeightManage ? 'min-w-[200px] mr-[24px]' : 'w-full'} ${isPercentage ? 'order-2' : ''}` },
                    isComplexity ? (react_1.default.createElement(AdjustCompexity_1.default, { objective: objective })) : (isPercentage &&
                        (0, has_1.default)(objective, 'weight') && (react_1.default.createElement(Slider_1.default, { isAllowToUpdate: isAllowToUpdate, objective: objective, dataCy: `slider-${objectiveId}` }))),
                    !isPercentage &&
                        objectiveCategories &&
                        !isComplexity &&
                        (0, has_1.default)(objective, 'objectiveCategory') && (react_1.default.createElement(AdjustCategory_1.default, { objective: objective, isAllowToUpdate: isAllowToUpdate }))),
                objectiveWeightManage && !isComplexity && (react_1.default.createElement("div", { className: `min-w-[124px] ${isPercentage ? 'order-1' : ''}` },
                    react_1.default.createElement("div", { className: "flex items-center" },
                        react_1.default.createElement(ToggleWeight_1.default, { objective: objective, usingWeight: usingWeight, isLocked: isLocked, isAllowToUpdate: isAllowToUpdate, index: index }),
                        react_1.default.createElement("div", { className: "flex items-center h-[32px]" }, usingWeight && (react_1.default.createElement(InputWeight_1.default, { objective: objective, isAllowToUpdate: isAllowToUpdate, isLocked: isLocked }))))))),
            isErrorWeightShow && (react_1.default.createElement("p", { className: "warning-message typography-h100 text-r-500 mt-[8px]", "data-cy": "warning-message" }, warningMessage)),
            isErrorLockedWeightShow && (react_1.default.createElement(WarningLockedWeight_1.default, { objective: objective })))));
}, areEqual);
AdjustWeightDetail.displayName = 'AdjustWeightDetail';
exports.default = AdjustWeightDetail;
